export default {
    listagem: {
        titulo_pagina: 'Lista de Métodos',
        novo: 'Crear Nuevo Método',
        habilitado: 'Capaz',
        desabilitado: 'Desactivado',
        table: {
            empty: 'No se encontró ningún método',
            nome: 'Nombre',
            codigo: 'Código',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Crear Nuevo Método',
            editar: 'Editar Método'
        },
        fields: {
            codigo: {
                label: 'Código',
                description: 'Código del Método'
            },
            nome: {
                label: 'Nombre',
                description: 'Nombre del Método'
            },
            status: {
                label: 'Estado',
                description: 'Estado activo o inactivo del método'
            },
            botao_salvar : 'Guardar Método'
        },
        create: {
            success: '¡Método creado con éxito!',
            error: '¡Error al crear el método!'
        },
        update: {
            success: '¡Método editado con éxito!',
            error: '¡Método de edición de error!'
        }
    }
}
